import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  toggle(event) {
    // Disable tab functionality if the tab has no data-tab, used for buttons as tabs.
    if (!event.currentTarget.getAttribute('data-tab')) {
      return;
    }

    for (const tabInner of this.element.querySelectorAll('.tab')) {
      tabInner.classList.remove('active');
    }

    for (const tabContent of this.element.querySelectorAll('.tab-content')) {
      tabContent.classList.remove('active');
      Array.prototype.forEach.call(tabContent.getElementsByClassName('input'), function(el) {
        if (!el.disabled) {
          el.disabled = true;
        }
      });
    }

    for (const content of this.element.querySelectorAll('.' + event.currentTarget.getAttribute('data-tab'))) {
      content.classList.add('active');
      Array.prototype.forEach.call(content.getElementsByClassName('input'), function(el) {
        if (el.disabled) {
          el.disabled = false;
        }
      });
    }

    event.currentTarget.classList.add('active');
  }
}
